import { ReactNode, useCallback, useState } from 'react'
import { createPortal } from 'react-dom'

interface ShadowRootWrapProps {
  children: (shadowRoot?: ShadowRoot) => ReactNode;
  id: string;
  mode?: ShadowRootMode;
}

export const ShadowRootWrap = ({ id, children, mode = 'open' }: ShadowRootWrapProps) => {
  const [shadow, setShadow] = useState<ShadowRoot | null>(null)

  const onMount = useCallback(
    (node: HTMLDivElement | null) => {
      if (node) {
        const root = node.attachShadow({
          mode,
        })

        setShadow(root)
      }
    },
    [setShadow],
  )

  return (
    <div id={id} ref={onMount}>
      {shadow && createPortal(children(shadow), shadow)}
    </div>
  )
}
